<template>
    <div class="nav" ref="navIgationRef">
        <img src="@/image/navLogo_new.png" class="navLogo" @click="$router.push({ path: '/' })" alt="">
        <img src="@/image/logo.png" class="logo" alt="">
        <div class="phone">
            <img src="@/image/phone.png" alt="">
            <img src="@/image/phone2.png" alt="">
            <span>18611285531</span>
        </div>
        <div class="view">
            <p v-for="(item, index) in list" :key="index + 'nav'" :class="sub == index ? 'rouP' : ''"
                @click="rouClick(item, index)">{{ item.name }}</p>
            <span :style="{ 'left': sub * 114 + 40 + 'px' }"></span>
        </div>
        <div class="mTem" v-show="!moveMenu" @click="moveClick(true)">
            <img src="@/image/Mmenu.png" alt="">
            <p>菜单</p>
        </div>
        <div class="mTem" v-show="moveMenu" @click="moveClick(false)">
            <img src="@/image/MmenuGuan.png" alt="">
            <p>关闭</p>
        </div>
        <div class="menu" v-show="moveMenu">
            <div class="item" v-for="(item, index) in list" :key="index + 'Mnav'" :class="sub == index ? 'rouP' : ''"
                @click="rouClick(item, index)">{{
                    item.name }}
                <img src="@/image/mNavP.png" alt="">
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'navIgation',
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            moveMenu: false,
            list: [
                {
                    name: '首页',
                    link: '/'
                },
                {
                    name: '中云工业园',
                    link: '/park'
                },
                {
                    name: '解决方案',
                    link: '/programme'
                },
                {
                    name: '绿色工业',
                    link: '/greenFactory'
                },
                {
                    name: '新闻中心',
                    link: '/news'
                },
                {
                    name: '服务平台',
                    link: 'https://zyzs.zhongyuncloud.com/#/login'
                },
                {
                    name: '关于我们',
                    link: '/AboutUs'
                },
                // {
                //     name: '软件应用'
                // },
            ],
            sub: 0
        }
    },
    // watch: {
    //     $route: {
    //         handler: function (val, oldVal) {
    //             console.log(val)
    //             this.list.forEach((item, index) => {
    //                 if (item.link == this.$route.path) {
    //                     inde = index
    //                 }
    //             })
    //             if (this.$route.path == '/newsInfo') {
    //                 this.sub = 4
    //             }
    //         },
    //         // 深度观察监听
    //         deep: true
    //     }
    // },
    mounted() {
        this.list.forEach((item, index) => {
            if (item.link == this.$route.path) {
                this.sub = index
            }
        })
        if (this.$route.path == '/promotionAssociation') {
            this.sub = 3
        }
        if (this.$route.path == '/carbonMeeting') {
            this.sub = 3
        }
        if (this.$route.path == '/alliance') {
            this.sub = 3
        }
        if (this.$route.path == '/newsInfo') {
            this.sub = 4
        }
    },
    methods: {
        moveClick(type) {
            var dom = this.$refs.navIgationRef
            var navLogo = dom.getElementsByClassName('navLogo')[0]
            var scrTop = (document.body.scrollTop || document.documentElement.scrollTop);
            console.log(scrTop)
            if (type) {
                dom.style = 'background:#fff'
                navLogo.style.display = 'block'
            } else if (scrTop <= 200) {
                dom.style = ''
                navLogo.style = ''
            }
            this.moveMenu = type
        },
        rouClick(item, inde) {
            if(item.name == '服务平台'){
                window.open(item.link)
                return;
            }
            this.$router.push({
                path: item.link
            })
            this.sub = inde
        }
    }
}
</script>
<style lang="scss" scoped>
.menu {
    width: 100%;
    height: calc(100vh - 80px);
    background: #fff;
    position: fixed;
    left: 0;
    top: 80px;
    padding-top: 10px;
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(1px);

    .item {
        height: 50px;
        font-size: 16px;
        color: #303133;
        line-height: 50px;
        margin: 0 20px;
        border-bottom: 1px solid #E5E5E5;

        img {
            width: 17px;
            float: right;
            margin-top: 16px;
            display: none;
        }
    }

    .rouP {
        color: #2EA7E0;

        img {
            display: inline;
        }

    }
}

.mTem {
    width: 45px;
    height: 45px;
    background: #2EA7E0;
    display: none;
    flex-direction: column;
    align-items: center;


    img {
        width: 33px;
    }

    p {
        font-size: 11px;
        text-align: center;
        color: #fff;
        margin-top: -7px;
    }
}

.white {
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(1px);

    .mTem {
        p {
            color: #fff !important;
        }
    }

    p {
        color: #303133 !important;
    }

    .rouP {
        color: #2EA7E0 !important;
    }

    .phone {
        color: #303133 !important;
    }

    .phone img {
        display: none !important;
    }

    .phone img:nth-child(2) {
        display: block !important;
    }

    .navLogo {
        display: block !important;
        cursor: pointer;
    }

    .logo {
        display: none !important;
    }
}

.nav {
    display: flex;
    height: 80px;
    width: calc(100% - 8%);
    padding: 0 4%;
    border-bottom: 1px solid rgba(255, 255, 255, .1);
    z-index: 20;

    .navLogo {
        display: none;
    }

    .logo {
        display: block;
    }

    .phone {
        span {
            flex-shrink: 0;
        }
    }

    .phone img {
        display: none;
    }

    .phone img:nth-child(1) {
        display: block;
    }

    .view {
        display: flex;
        position: relative;

        span {
            position: absolute;
            bottom: 0;
            display: block;
            width: 32px;
            height: 2px;
            background: linear-gradient(270deg, #00AAFF 0%, #4D5EFA 49%, #A259FB 100%);
            border-radius: 1px;
            transition: left 0.5s ease; // 核心代码是这一行
        }

        p {
            height: 80px;
            width: 114px;
            font-size: 16px;
            line-height: 80px;
            color: #fff;
            text-align: center;
            cursor: pointer;
        }
    }

    .logo {
        height: 100%;
    }

    .phone {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #fff;
        margin-left: 8%;
        margin-right: 50px;
        flex: 1;

        img {
            width: 24px;
            margin-right: 12px
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/navIgation.vue